module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "small"
  }), _vm._v(" "), _c('h2', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Contents"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface#toc_marker-2"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Preface:")]), _vm._v(" The Biblical Imagination")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Thanks"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Thanks")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction#toc_marker-3"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Introduction:")]), _vm._v(" Learning to Listen to Matthew")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/MajorThemes#toc_marker-4"
    }
  }, [_vm._v("Major Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/MajorThemes#toc_marker-4-1"
    }
  }, [_vm._v("The Crisis in Galilee")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/MajorThemes#toc_marker-4-2"
    }
  }, [_vm._v("The Gospel of Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Matthew1#toc_marker-5"
    }
  }, [_vm._v("Matthew 1")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Matthew1#toc_marker-5-1"
    }
  }, [_vm._v("The Messiah’s Pedigree")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Matthew1#toc_marker-5-2"
    }
  }, [_vm._v("A Dream Come True")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew2#toc_marker-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 2")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew2#toc_marker-6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World’s Wisdom Bows Down")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew2#toc_marker-6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew3#toc_marker-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 3")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew3#toc_marker-7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Voice of One in the Wilderness")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew3#toc_marker-7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Perfect Words of the Father")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew4#toc_marker-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 4")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew4#toc_marker-8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Temptation in the Wilderness")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew4#toc_marker-8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preaching in Galilee")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew4#toc_marker-8-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Disciples, the First Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew5#toc_marker-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 5")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew5#toc_marker-9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Nine Benedictions")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew5#toc_marker-9-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus, Tell Us Who We Are")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew5#toc_marker-9-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Unexpected Fulfillment")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew5#toc_marker-9-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Righteousness")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew6#toc_marker-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 6")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew6#toc_marker-10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Secret Righteousness")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew6#toc_marker-10-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("True Treasure")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew6#toc_marker-10-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Be Worry Free")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew7#toc_marker-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 7")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew7#toc_marker-11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do Not Judge")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew7#toc_marker-11-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do Not Give Up Asking")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew7#toc_marker-11-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew8#toc_marker-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 8")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew8#toc_marker-12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Disobedient Leper")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew8#toc_marker-12-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Confident Centurion")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew8#toc_marker-12-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The One Who Carries Our Illness")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew8#toc_marker-12-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Homeless Son of Man")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew8#toc_marker-12-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Demonic Confrontations")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew9#toc_marker-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 9")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew9#toc_marker-13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winning Praise for God")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew9#toc_marker-13-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Calling of Matthew")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew9#toc_marker-13-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Orthodoxy, New Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew9#toc_marker-13-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power over Disease and Death")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew9#toc_marker-13-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Request He Will Never Deny")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew9#toc_marker-13-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Synagogue Tour")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew10#toc_marker-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 10")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew10#toc_marker-14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appointing the Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew10#toc_marker-14-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instructions to the Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew11#toc_marker-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 11")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew11#toc_marker-15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Failure to Meet Expectations")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew11#toc_marker-15-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capernaum and Sodom")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew11#toc_marker-15-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Painful Joy of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew12#toc_marker-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 12")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew12#toc_marker-16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Identity of Jesus: Lord of the Sabbath")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew12#toc_marker-16-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fearless Healer")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew12#toc_marker-16-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Gentle Servant")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew12#toc_marker-16-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Son of David")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew12#toc_marker-16-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greater Than Jonah and Solomon")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew12#toc_marker-16-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Family of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew13#toc_marker-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 13")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew13#toc_marker-17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Parable of the Soils")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew13#toc_marker-17-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Parable of the Weeds")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew13#toc_marker-17-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Parable of the Mustard Seed and the Yeast")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew13#toc_marker-17-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Parables Unique to Matthew")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew13#toc_marker-17-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of the Synagogue Ministry")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew14#toc_marker-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 14")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew14#toc_marker-18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ludicrous Death of John")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew14#toc_marker-18-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Miracle of Perfect Provision")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew14#toc_marker-18-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Their First Time to Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew15#toc_marker-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 15")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew15#toc_marker-19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus Attacks the Oral Law")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew15#toc_marker-19-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread for the Puppies")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew15#toc_marker-19-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Miracle of Abundance")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew16#toc_marker-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 16")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew16#toc_marker-20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engaging the Pharisees")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew16#toc_marker-20-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Yeast of the Pharisees")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew16#toc_marker-20-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter’s Confession and Blessing")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew16#toc_marker-20-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter’s Rebuke and Cursing")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew17#toc_marker-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 17")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew17#toc_marker-21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Transfiguration")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew17#toc_marker-21-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Have Mercy”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew17#toc_marker-21-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Unmiraculous Miracle")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew18#toc_marker-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 18")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew18#toc_marker-22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Is the Greatest?")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew18#toc_marker-22-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lonely lost Sheep")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew18#toc_marker-22-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Process of Forgiving Your Brother")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew18#toc_marker-22-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Willingness to Forgive Little")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew19#toc_marker-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 19")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew19#toc_marker-23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divorce and the Little Children")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew19#toc_marker-23-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Flawed Question")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew20#toc_marker-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 20")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew20#toc_marker-24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eccentric Employer: A Parable of HESED")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew20#toc_marker-24-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Announcement of Suffering")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew20#toc_marker-24-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Request to Be First")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew20#toc_marker-24-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Blind Men")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew21#toc_marker-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 21")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew21#toc_marker-25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Triumphal” Entry")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew21#toc_marker-25-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prophet is in the Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew21#toc_marker-25-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lesson from the Leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew21#toc_marker-25-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions of Authority")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew21#toc_marker-25-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Worker Parables")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew22#toc_marker-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 22")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew22#toc_marker-26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wedding Feast")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew22#toc_marker-26-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Controversy Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew22#toc_marker-26-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Coup De GrÂce")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew23#toc_marker-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 23")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew23#toc_marker-27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven Woes")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew23#toc_marker-27-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Lament")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew24#toc_marker-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 24")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew24#toc_marker-28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Questions, Two Answers")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew24#toc_marker-28-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Parable about Not Knowing")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew25#toc_marker-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 25")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew25#toc_marker-29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ten Virgins")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew25#toc_marker-29-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Talents")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew25#toc_marker-29-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sheep and the Goats")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew26#toc_marker-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 26")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew26#toc_marker-30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plot Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew26#toc_marker-30-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Anointing")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew26#toc_marker-30-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Deal Is Closed")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew26#toc_marker-30-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Supper")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew26#toc_marker-30-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew26#toc_marker-30-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Arrest")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew26#toc_marker-30-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before Caiaphas")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew26#toc_marker-30-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Redemptive Tears")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew27#toc_marker-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 27")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew27#toc_marker-31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sickness unto Death")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew27#toc_marker-31-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before Pilate")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew27#toc_marker-31-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Vegetative Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew27#toc_marker-31-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus Crucified")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew27#toc_marker-31-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus “Dismisses” His Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew27#toc_marker-31-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rich Man’s Tomb")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew27#toc_marker-31-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Make the Tomb Secure”")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew28#toc_marker-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 28")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew28#toc_marker-32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Resurrection")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew28#toc_marker-32-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bribe")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Matthew28#toc_marker-32-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus Meets Them Back Home")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixA#toc_marker-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixB#toc_marker-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixC#toc_marker-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixD#toc_marker-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix D")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixE#toc_marker-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix E")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#toc_marker-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Resources#toc_marker-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AboutTheAuthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Series",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Series")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Series",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Biblical Imagination Series")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Series#toc_marker-41-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also Available from InterVarsity Press:")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8cef8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 63
// module chunks = 0